export const organizations = {
  rows: [
    {
      id: 41,
      name: 'Lhotse Medical Org',
      ownerId: 'Yes',
      siteId: 'Yes',
      reverseProxy: 'No',
      subdomain: null,
      isAthenaEnabled: true,
      athenaDefaultDepartmentId: 2,
      athenaDepartments: [
        {
          id: 1,
          name: 'Flyte Medical',
          timezoneOffset: -5,
          timezoneName: 'America/New_York',
          providerGroupName: 'Flyte Medical PC',
          patientDepartmentName: 'Flyte Medical',
        },
        {
          id: 2,
          name: 'SIA Medical',
          timezoneOffset: -5,
          timezoneName: 'America/New_York',
          providerGroupName: 'SIA Medical PC',
          patientDepartmentName: 'SIA Medical',
        },
        {
          id: 3,
          name: 'Dietician Schedule- Flyte Nutritional',
          timezoneOffset: -5,
          timezoneName: 'America/New_York',
          providerGroupName: 'Flyte Medical PC',
          patientDepartmentName: 'Dietician Schedule- Flyte Nutritional',
        },
        {
          id: 4,
          name: 'Dietician Schedule - SIA Nutritional',
          timezoneOffset: -5,
          timezoneName: 'America/New_York',
          providerGroupName: 'SIA Medical PC',
          patientDepartmentName: 'Dietician Schedule - SIA Nutritional',
        },
      ],
      athenaProviders: [
        {
          id: 3,
          schedulingName: 'ARAS_M',
          name: 'Mohini Aras',
        },
        {
          id: 8,
          schedulingName: 'CIZINSKI_D',
          name: 'Dana Cizinski',
        },
        {
          id: 5,
          schedulingName: 'DICKISON_M',
          name: 'Morgan Dickison',
        },
        {
          id: 1,
          schedulingName: 'IGEL_L',
          name: 'Leon Igel',
        },
        {
          id: 10,
          schedulingName: 'LAKTASH_A',
          name: 'Amy Laktash',
        },
        {
          id: 9,
          schedulingName: 'LESCH_N',
          name: 'Nathan Lesch',
        },
        {
          id: 7,
          schedulingName: 'PALOMINO_M',
          name: 'Martha Palomino',
        },
        {
          id: 4,
          schedulingName: 'REDMOND_I',
          name: 'Ilana Redmond',
        },
        {
          id: 2,
          schedulingName: 'SAUNDERS_K',
          name: 'Katherine Saunders',
        },
        {
          id: 6,
          schedulingName: 'SCHWARTZ_J',
          name: 'Julie Schwartz',
        },
        {
          id: 11,
          schedulingName: 'VANNORTWICK_M',
          name: 'Mary Vannortwick',
        },
      ],
    },
    {
      id: 8,
      name: 'Armenia Medical Center',
      ownerId: 'Yes',
      siteId: 'Yes',
      reverseProxy: 'No',
      subdomain: null,
      isAthenaEnabled: true,
      athenaDefaultDepartmentId: 1,
      athenaDepartments: [
        {
          id: 1,
          name: 'Flyte Medical',
          timezoneOffset: -5,
          timezoneName: 'America/New_York',
          providerGroupName: 'Flyte Medical PC',
          patientDepartmentName: 'Flyte Medical',
        },
        {
          id: 2,
          name: 'SIA Medical',
          timezoneOffset: -5,
          timezoneName: 'America/New_York',
          providerGroupName: 'SIA Medical PC',
          patientDepartmentName: 'SIA Medical',
        },
        {
          id: 3,
          name: 'Dietician Schedule- Flyte Nutritional',
          timezoneOffset: -5,
          timezoneName: 'America/New_York',
          providerGroupName: 'Flyte Medical PC',
          patientDepartmentName: 'Dietician Schedule- Flyte Nutritional',
        },
        {
          id: 4,
          name: 'Dietician Schedule - SIA Nutritional',
          timezoneOffset: -5,
          timezoneName: 'America/New_York',
          providerGroupName: 'SIA Medical PC',
          patientDepartmentName: 'Dietician Schedule - SIA Nutritional',
        },
      ],
      athenaProviders: [
        {
          id: 3,
          schedulingName: 'ARAS_M',
          name: 'Mohini Aras',
        },
        {
          id: 8,
          schedulingName: 'CIZINSKI_D',
          name: 'Dana Cizinski',
        },
        {
          id: 5,
          schedulingName: 'DICKISON_M',
          name: 'Morgan Dickison',
        },
        {
          id: 1,
          schedulingName: 'IGEL_L',
          name: 'Leon Igel',
        },
        {
          id: 10,
          schedulingName: 'LAKTASH_A',
          name: 'Amy Laktash',
        },
        {
          id: 9,
          schedulingName: 'LESCH_N',
          name: 'Nathan Lesch',
        },
        {
          id: 7,
          schedulingName: 'PALOMINO_M',
          name: 'Martha Palomino',
        },
        {
          id: 4,
          schedulingName: 'REDMOND_I',
          name: 'Ilana Redmond',
        },
        {
          id: 2,
          schedulingName: 'SAUNDERS_K',
          name: 'Katherine Saunders',
        },
        {
          id: 6,
          schedulingName: 'SCHWARTZ_J',
          name: 'Julie Schwartz',
        },
        {
          id: 11,
          schedulingName: 'VANNORTWICK_M',
          name: 'Mary Vannortwick',
        },
      ],
    },
    {
      id: 11,
      name: 'Arevik Medical Center',
      ownerId: 'Yes',
      siteId: 'Yes',
      reverseProxy: 'No',
      subdomain: null,
      isAthenaEnabled: false,
      athenaDefaultDepartmentId: null,
    },
    {
      id: 1,
      name: 'Core Hospitals of America',
      ownerId: 'Yes',
      siteId: 'Yes',
      reverseProxy: 'No',
      subdomain: null,
      isAthenaEnabled: true,
      athenaDefaultDepartmentId: 2,
      athenaDepartments: [
        {
          id: 1,
          name: 'Flyte Medical',
          timezoneOffset: -5,
          timezoneName: 'America/New_York',
          providerGroupName: 'Flyte Medical PC',
          patientDepartmentName: 'Flyte Medical',
        },
        {
          id: 2,
          name: 'SIA Medical',
          timezoneOffset: -5,
          timezoneName: 'America/New_York',
          providerGroupName: 'SIA Medical PC',
          patientDepartmentName: 'SIA Medical',
        },
        {
          id: 3,
          name: 'Dietician Schedule- Flyte Nutritional',
          timezoneOffset: -5,
          timezoneName: 'America/New_York',
          providerGroupName: 'Flyte Medical PC',
          patientDepartmentName: 'Dietician Schedule- Flyte Nutritional',
        },
        {
          id: 4,
          name: 'Dietician Schedule - SIA Nutritional',
          timezoneOffset: -5,
          timezoneName: 'America/New_York',
          providerGroupName: 'SIA Medical PC',
          patientDepartmentName: 'Dietician Schedule - SIA Nutritional',
        },
      ],
      athenaProviders: [
        {
          id: 3,
          schedulingName: 'ARAS_M',
          name: 'Mohini Aras',
        },
        {
          id: 8,
          schedulingName: 'CIZINSKI_D',
          name: 'Dana Cizinski',
        },
        {
          id: 5,
          schedulingName: 'DICKISON_M',
          name: 'Morgan Dickison',
        },
        {
          id: 1,
          schedulingName: 'IGEL_L',
          name: 'Leon Igel',
        },
        {
          id: 10,
          schedulingName: 'LAKTASH_A',
          name: 'Amy Laktash',
        },
        {
          id: 9,
          schedulingName: 'LESCH_N',
          name: 'Nathan Lesch',
        },
        {
          id: 7,
          schedulingName: 'PALOMINO_M',
          name: 'Martha Palomino',
        },
        {
          id: 4,
          schedulingName: 'REDMOND_I',
          name: 'Ilana Redmond',
        },
        {
          id: 2,
          schedulingName: 'SAUNDERS_K',
          name: 'Katherine Saunders',
        },
        {
          id: 6,
          schedulingName: 'SCHWARTZ_J',
          name: 'Julie Schwartz',
        },
        {
          id: 11,
          schedulingName: 'VANNORTWICK_M',
          name: 'Mary Vannortwick',
        },
      ],
    },
    {
      id: 5,
      name: 'Clover Medical System',
      ownerId: 'Yes',
      siteId: 'Yes',
      reverseProxy: 'No',
      subdomain: null,
      isAthenaEnabled: true,
      athenaDefaultDepartmentId: 2,
      athenaDepartments: [
        {
          id: 1,
          name: 'Flyte Medical',
          timezoneOffset: -5,
          timezoneName: 'America/New_York',
          providerGroupName: 'Flyte Medical PC',
          patientDepartmentName: 'Flyte Medical',
        },
        {
          id: 2,
          name: 'SIA Medical',
          timezoneOffset: -5,
          timezoneName: 'America/New_York',
          providerGroupName: 'SIA Medical PC',
          patientDepartmentName: 'SIA Medical',
        },
        {
          id: 3,
          name: 'Dietician Schedule- Flyte Nutritional',
          timezoneOffset: -5,
          timezoneName: 'America/New_York',
          providerGroupName: 'Flyte Medical PC',
          patientDepartmentName: 'Dietician Schedule- Flyte Nutritional',
        },
        {
          id: 4,
          name: 'Dietician Schedule - SIA Nutritional',
          timezoneOffset: -5,
          timezoneName: 'America/New_York',
          providerGroupName: 'SIA Medical PC',
          patientDepartmentName: 'Dietician Schedule - SIA Nutritional',
        },
      ],
      athenaProviders: [
        {
          id: 3,
          schedulingName: 'ARAS_M',
          name: 'Mohini Aras',
        },
        {
          id: 8,
          schedulingName: 'CIZINSKI_D',
          name: 'Dana Cizinski',
        },
        {
          id: 5,
          schedulingName: 'DICKISON_M',
          name: 'Morgan Dickison',
        },
        {
          id: 1,
          schedulingName: 'IGEL_L',
          name: 'Leon Igel',
        },
        {
          id: 10,
          schedulingName: 'LAKTASH_A',
          name: 'Amy Laktash',
        },
        {
          id: 9,
          schedulingName: 'LESCH_N',
          name: 'Nathan Lesch',
        },
        {
          id: 7,
          schedulingName: 'PALOMINO_M',
          name: 'Martha Palomino',
        },
        {
          id: 4,
          schedulingName: 'REDMOND_I',
          name: 'Ilana Redmond',
        },
        {
          id: 2,
          schedulingName: 'SAUNDERS_K',
          name: 'Katherine Saunders',
        },
        {
          id: 6,
          schedulingName: 'SCHWARTZ_J',
          name: 'Julie Schwartz',
        },
        {
          id: 11,
          schedulingName: 'VANNORTWICK_M',
          name: 'Mary Vannortwick',
        },
      ],
    },
    {
      id: 65,
      name: 'JIB Tester Hospital',
      ownerId: 'Yes',
      siteId: 'Yes',
      reverseProxy: 'No',
      subdomain: null,
      isAthenaEnabled: true,
      athenaDefaultDepartmentId: 2,
      athenaDepartments: [
        {
          id: 1,
          name: 'Flyte Medical',
          timezoneOffset: -5,
          timezoneName: 'America/New_York',
          providerGroupName: 'Flyte Medical PC',
          patientDepartmentName: 'Flyte Medical',
        },
        {
          id: 2,
          name: 'SIA Medical',
          timezoneOffset: -5,
          timezoneName: 'America/New_York',
          providerGroupName: 'SIA Medical PC',
          patientDepartmentName: 'SIA Medical',
        },
        {
          id: 3,
          name: 'Dietician Schedule- Flyte Nutritional',
          timezoneOffset: -5,
          timezoneName: 'America/New_York',
          providerGroupName: 'Flyte Medical PC',
          patientDepartmentName: 'Dietician Schedule- Flyte Nutritional',
        },
        {
          id: 4,
          name: 'Dietician Schedule - SIA Nutritional',
          timezoneOffset: -5,
          timezoneName: 'America/New_York',
          providerGroupName: 'SIA Medical PC',
          patientDepartmentName: 'Dietician Schedule - SIA Nutritional',
        },
      ],
      athenaProviders: [
        {
          id: 3,
          schedulingName: 'ARAS_M',
          name: 'Mohini Aras',
        },
        {
          id: 8,
          schedulingName: 'CIZINSKI_D',
          name: 'Dana Cizinski',
        },
        {
          id: 5,
          schedulingName: 'DICKISON_M',
          name: 'Morgan Dickison',
        },
        {
          id: 1,
          schedulingName: 'IGEL_L',
          name: 'Leon Igel',
        },
        {
          id: 10,
          schedulingName: 'LAKTASH_A',
          name: 'Amy Laktash',
        },
        {
          id: 9,
          schedulingName: 'LESCH_N',
          name: 'Nathan Lesch',
        },
        {
          id: 7,
          schedulingName: 'PALOMINO_M',
          name: 'Martha Palomino',
        },
        {
          id: 4,
          schedulingName: 'REDMOND_I',
          name: 'Ilana Redmond',
        },
        {
          id: 2,
          schedulingName: 'SAUNDERS_K',
          name: 'Katherine Saunders',
        },
        {
          id: 6,
          schedulingName: 'SCHWARTZ_J',
          name: 'Julie Schwartz',
        },
        {
          id: 11,
          schedulingName: 'VANNORTWICK_M',
          name: 'Mary Vannortwick',
        },
      ],
    },
    {
      id: 22,
      name: 'Federacy Hospital System',
      ownerId: 'Yes',
      siteId: 'No',
      reverseProxy: 'Yes',
      subdomain: null,
      isAthenaEnabled: false,
      athenaDefaultDepartmentId: null,
    },
    {
      id: 62,
      name: 'Moderna',
      ownerId: 'Yes',
      siteId: 'No',
      reverseProxy: 'No',
      subdomain: null,
      isAthenaEnabled: false,
      athenaDefaultDepartmentId: null,
    },
    {
      id: 60,
      name: 'Esthetic clinic',
      ownerId: 'Yes',
      siteId: 'No',
      reverseProxy: 'No',
      subdomain: null,
      isAthenaEnabled: false,
      athenaDefaultDepartmentId: null,
    },
    {
      id: 59,
      name: 'OnePiece organization',
      ownerId: 'Yes',
      siteId: 'No',
      reverseProxy: 'No',
      subdomain: null,
      isAthenaEnabled: false,
      athenaDefaultDepartmentId: null,
    },
    {
      id: 57,
      name: 'Georgia Health System',
      ownerId: 'Yes',
      siteId: 'No',
      reverseProxy: 'No',
      subdomain: null,
      isAthenaEnabled: false,
      athenaDefaultDepartmentId: null,
    },
    {
      id: 10,
      name: 'Texas Medical Organization',
      ownerId: 'Yes',
      siteId: 'Yes',
      reverseProxy: 'No',
      subdomain: null,
      isAthenaEnabled: false,
      athenaDefaultDepartmentId: null,
    },
    {
      id: 37,
      name: 'Oxygen',
      ownerId: 'Yes',
      siteId: 'No',
      reverseProxy: 'No',
      subdomain: null,
      isAthenaEnabled: false,
      athenaDefaultDepartmentId: null,
    },
    {
      id: 52,
      name: 'Healthy lifestyle',
      ownerId: 'Yes',
      siteId: 'No',
      reverseProxy: 'No',
      subdomain: null,
      isAthenaEnabled: false,
      athenaDefaultDepartmentId: null,
    },
    {
      id: 48,
      name: 'SuryaHospitals',
      ownerId: 'Yes',
      siteId: 'No',
      reverseProxy: 'No',
      subdomain: null,
      isAthenaEnabled: false,
      athenaDefaultDepartmentId: null,
    },
    {
      id: 31,
      name: 'Avanta',
      ownerId: 'Yes',
      siteId: 'Yes',
      reverseProxy: 'No',
      subdomain: null,
      isAthenaEnabled: false,
      athenaDefaultDepartmentId: null,
    },
    {
      id: 34,
      name: 'Sample Weill Cornell Internal Medicine Associates (WCIMA)',
      ownerId: 'Yes',
      siteId: 'No',
      reverseProxy: 'No',
      subdomain: null,
      isAthenaEnabled: false,
      athenaDefaultDepartmentId: null,
    },
    {
      id: 33,
      name: 'Sample Comprehensive Weight Control Center (CWCC)',
      ownerId: 'Yes',
      siteId: 'No',
      reverseProxy: 'No',
      subdomain: null,
      isAthenaEnabled: false,
      athenaDefaultDepartmentId: null,
    },
    {
      id: 7,
      name: 'Oregon Hospital Group',
      ownerId: 'Yes',
      siteId: 'Yes',
      reverseProxy: 'No',
      subdomain: null,
      isAthenaEnabled: false,
      athenaDefaultDepartmentId: null,
    },
    {
      id: 14,
      name: 'CWCC Wellness Program',
      ownerId: 'Yes',
      siteId: 'Yes',
      reverseProxy: 'No',
      subdomain: null,
      isAthenaEnabled: false,
      athenaDefaultDepartmentId: null,
    },
    {
      id: 16,
      name: 'United Sharing Wellness Program',
      ownerId: 'Yes',
      siteId: 'Yes',
      reverseProxy: 'No',
      subdomain: null,
      isAthenaEnabled: false,
      athenaDefaultDepartmentId: null,
    },
    {
      id: 19,
      name: 'Org 11/18 - Lus',
      ownerId: 'Yes',
      siteId: 'Yes',
      reverseProxy: 'No',
      subdomain: null,
      isAthenaEnabled: false,
      athenaDefaultDepartmentId: null,
    },
    {
      id: 15,
      name: 'KCGI Wellness Program',
      ownerId: 'Yes',
      siteId: 'Yes',
      reverseProxy: 'No',
      subdomain: null,
      isAthenaEnabled: false,
      athenaDefaultDepartmentId: null,
    },
    {
      id: 18,
      name: 'Lus Org',
      ownerId: 'Yes',
      siteId: 'Yes',
      reverseProxy: 'No',
      subdomain: null,
      isAthenaEnabled: false,
      athenaDefaultDepartmentId: null,
    },
    {
      id: 17,
      name: 'Overview Sharing Wellness Program',
      ownerId: 'Yes',
      siteId: 'Yes',
      reverseProxy: 'No',
      subdomain: null,
      isAthenaEnabled: false,
      athenaDefaultDepartmentId: null,
    },
    {
      id: 6,
      name: 'JIB Wellness Program',
      ownerId: 'Yes',
      siteId: 'Yes',
      reverseProxy: 'No',
      subdomain: null,
      isAthenaEnabled: false,
      athenaDefaultDepartmentId: null,
    },
    {
      id: 13,
      name: 'Houston Medical Center',
      ownerId: 'Yes',
      siteId: 'Yes',
      reverseProxy: 'No',
      subdomain: null,
      isAthenaEnabled: false,
      athenaDefaultDepartmentId: null,
    },
  ],
  count: 27,
};
export const singleOrganization = {
  id: 8,
  accessCode: 'F4F262J3',
  defaultAppointmentId: 70,
  defaultProviderId: 95,
  allowSelfEnrollment: true,
  name: 'Test Medical Center',
  active: true,
  siteId: 1027,
  address: null,
  city: 'Los Angeles',
  subdomain: null,
  useReverseProxy: false,
  timezone: null,
  authEnabled: false,
  createdAt: '2020-04-30T15:07:17.624Z',
  updatedAt: '2021-05-11T08:48:57.798Z',
  createdBy: null,
  updatedBy: 1,
  ownerId: 199,
  countryId: 1,
  isAthenaEnabled: true,
  athenaDefaultDepartmentId: 1,
  stateId: 6,
  zipCodeId: null,
  athenaProviders: [
    {
      id: 3,
      schedulingName: 'ARAS_M',
      name: 'Mohini Aras',
    },
    {
      id: 8,
      schedulingName: 'CIZINSKI_D',
      name: 'Dana Cizinski',
    },
    {
      id: 5,
      schedulingName: 'DICKISON_M',
      name: 'Morgan Dickison',
    },
    {
      id: 1,
      schedulingName: 'IGEL_L',
      name: 'Leon Igel',
    },
    {
      id: 10,
      schedulingName: 'LAKTASH_A',
      name: 'Amy Laktash',
    },
    {
      id: 9,
      schedulingName: 'LESCH_N',
      name: 'Nathan Lesch',
    },
    {
      id: 7,
      schedulingName: 'PALOMINO_M',
      name: 'Martha Palomino',
    },
    {
      id: 4,
      schedulingName: 'REDMOND_I',
      name: 'Ilana Redmond',
    },
    {
      id: 2,
      schedulingName: 'SAUNDERS_K',
      name: 'Katherine Saunders',
    },
    {
      id: 6,
      schedulingName: 'SCHWARTZ_J',
      name: 'Julie Schwartz',
    },
    {
      id: 11,
      schedulingName: 'VANNORTWICK_M',
      name: 'Mary Vannortwick',
    },
  ],
  athenaDepartments: [
    {
      id: 1,
      name: 'Flyte Medical',
      timezoneOffset: -5,
      timezoneName: 'America/New_York',
      providerGroupName: 'Flyte Medical PC',
      patientDepartmentName: 'Flyte Medical',
    },
    {
      id: 2,
      name: 'SIA Medical',
      timezoneOffset: -5,
      timezoneName: 'America/New_York',
      providerGroupName: 'SIA Medical PC',
      patientDepartmentName: 'SIA Medical',
    },
    {
      id: 3,
      name: 'Dietician Schedule- Flyte Nutritional',
      timezoneOffset: -5,
      timezoneName: 'America/New_York',
      providerGroupName: 'Flyte Medical PC',
      patientDepartmentName: 'Dietician Schedule- Flyte Nutritional',
    },
    {
      id: 4,
      name: 'Dietician Schedule - SIA Nutritional',
      timezoneOffset: -5,
      timezoneName: 'America/New_York',
      providerGroupName: 'SIA Medical PC',
      patientDepartmentName: 'Dietician Schedule - SIA Nutritional',
    },
  ],
  organization_programs: [
    {
      id: 68,
      programId: 13,
      organizationId: 11,
      deletedAt: null,
      isDefault: false,
      createdAt: '2021-04-29T11:54:05.779Z',
      updatedAt: '2021-05-11T08:48:33.777Z',
      createdBy: 1,
      updatedBy: 1,
      program: {
        name: 'TransforMe',
        id: 13,
        patients: [],
      },
    },
    {
      id: 49,
      programId: 18,
      organizationId: 11,
      deletedAt: null,
      isDefault: true,
      createdAt: '2020-11-17T13:59:32.491Z',
      updatedAt: '2021-05-11T08:48:33.788Z',
      createdBy: 1,
      updatedBy: 1,
      program: {
        name: 'Program Testing',
        id: 18,
        patients: [
          {
            programId: 18,
            id: 278,
            userId: 500,
            organizations_patients: [
              {
                id: 239,
                organizationId: 11,
                patientId: 278,
                deletedAt: null,
                createdAt: '2021-03-11T13:07:48.252Z',
                updatedAt: '2021-03-11T13:07:48.252Z',
                createdBy: 1,
                updatedBy: 1,
              },
            ],
          },
        ],
      },
    },
    {
      id: 47,
      programId: 17,
      organizationId: 11,
      deletedAt: null,
      isDefault: false,
      createdAt: '2020-11-16T21:20:11.932Z',
      updatedAt: '2021-05-11T08:48:33.777Z',
      createdBy: 1,
      updatedBy: 1,
      program: {
        name: 'Lus Program',
        id: 17,
        patients: [
          {
            programId: 17,
            id: 216,
            userId: 377,
            organizations_patients: [
              {
                id: 177,
                organizationId: 11,
                patientId: 216,
                deletedAt: null,
                createdAt: '2020-11-16T21:20:57.420Z',
                updatedAt: '2020-11-16T21:20:57.420Z',
                createdBy: 1,
                updatedBy: 1,
              },
            ],
          },
        ],
      },
    },
    {
      id: 41,
      programId: 12,
      organizationId: 11,
      deletedAt: null,
      isDefault: false,
      createdAt: '2020-11-11T13:54:32.389Z',
      updatedAt: '2021-05-11T08:48:33.777Z',
      createdBy: 1,
      updatedBy: 1,
      program: {
        name: 'a program to test',
        id: 12,
        patients: [
          {
            programId: 12,
            id: 277,
            userId: 499,
            organizations_patients: [
              {
                id: 238,
                organizationId: 11,
                patientId: 277,
                deletedAt: null,
                createdAt: '2021-03-11T13:02:41.172Z',
                updatedAt: '2021-03-11T13:02:41.172Z',
                createdBy: 1,
                updatedBy: 1,
              },
            ],
          },
        ],
      },
    },
    {
      id: 37,
      programId: 1,
      organizationId: 11,
      deletedAt: null,
      isDefault: false,
      createdAt: '2020-11-06T17:35:12.579Z',
      updatedAt: '2021-05-11T08:48:33.777Z',
      createdBy: 1,
      updatedBy: 1,
      program: {
        name: 'Core 12 Month Program',
        id: 1,
        patients: [
          {
            programId: 1,
            id: 228,
            userId: 398,
            organizations_patients: [],
          },
        ],
      },
    },
  ],
  organization_groups: [
    {
      name: 'test group',
      id: 2,
    },
    {
      name: 'test1',
      id: 3,
    },
  ],
  organization_ehr_platforms: [
    {
      id: 34,
      ehrPlatformId: 20,
      facility: '741123',
      excludedReceives: [],
      excludedSends: [],
    },
  ],
  organization_providers: [
    {
      id: 137,
      provider: {
        id: 62,
        providers_users: [
          {
            fullName: 'test prov 1',
            providerId: 62,
          },
        ],
      },
    },
    {
      id: 249,
      provider: {
        id: 108,
        providers_users: [
          {
            fullName: 'test prov 2',
            providerId: 108,
          },
        ],
      },
    },
  ],
  organization_devices: [
    {
      id: 117,
      device: {
        label: 'Intellihealth Evolve Blood Pressure Cuff',
        value: 12,
        name: 'bloodPressure',
        key: 2,
      },
    },
    {
      id: 116,
      device: {
        label: 'Intellihealth Evolve Scale',
        value: 11,
        name: 'weight',
        key: 1,
      },
    },
  ],
  vpnEnabled: false,
  vpnSettings: null,
};
